<template>
  <div class="relative min-w-0 lg:flex lg:items-center">
    <label class="sr-only lg:not-sr-only lg:flex-shrink-0 lg:pr-2" :for="id">{{ label }}</label>

    <!-- Outline for keyboard users only (Chrome treats a clicked select as keyboard focus) -->
    <div class="group relative w-full lg:w-56 rounded-full" :class="{ 'has-[:focus]:ring-2 has-[:focus]:ring-dark': !usingPointer }">
      <!-- The pill shows the chosen option itself, so long names end in "…" in every browser (Safari can't do that in a select).
           The real select sits invisibly on top. On phones the label sits inside the pill too. -->
      <div
        class="flex flex-col justify-center h-12 lg:h-11 pl-4 lg:pl-5 pr-12 lg:pr-14 rounded-full border border-solid transition-colors"
        :class="isActive ? 'bg-light border-default' : 'bg-light lg:bg-white lg:group-hover:bg-light border-light'"
        aria-hidden="true"
      >
        <span class="lg:hidden text-xs leading-tight text-grey">{{ label }}</span>
        <span class="text-sm lg:text-base leading-tight text-dark truncate">{{ selectedLabel }}</span>
      </div>

      <select
        :id="id"
        class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        :value="modelValue"
        @change="choose($event.target.value)"
        @pointerdown="usingPointer = true"
        @keydown="usingPointer = false"
        @blur="usingPointer = false"
      >
        <option value="">{{ allLabel }}</option>
        <option v-for="option in options" :key="option.value" :value="option.value">{{ option.label }}</option>
      </select>

      <!-- Ochre circle and border once an option is chosen, so it's clear the filter is in use -->
      <span
        class="pointer-events-none absolute right-2 top-2 lg:right-0 lg:top-0 flex justify-center items-center w-8 h-8 lg:w-11 lg:h-11 rounded-full border border-solid transition-colors"
        :class="isActive ? 'border-default bg-default' : 'border-white bg-dark'"
      >
        <svg class="w-3 lg:w-4 h-auto" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M7.19732 9.22748L0.347826 2.37798C-0.115942 1.94989 -0.115942 1.20072 0.347826 0.772631C0.77592 0.308863 1.52508 0.308863 1.95318 0.772631L8.01784 6.80162L14.0468 0.772631C14.4749 0.308863 15.2241 0.308863 15.6522 0.772631C16.1159 1.20072 16.1159 1.94989 15.6522 2.37798L8.80268 9.22748C8.37458 9.69125 7.62542 9.69125 7.19732 9.22748Z" :class="isActive ? 'fill-dark' : 'fill-light'"/>
        </svg>
      </span>
    </div>
  </div>
</template>
<script>
import { trackEvent } from "../../helpers/track"

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    allLabel: {
      type: String,
      default: "All",
    },
    options: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      usingPointer: false,
    }
  },
  computed: {
    isActive() {
      return this.modelValue !== ""
    },
    selectedLabel() {
      return this.options.find((option) => option.value === this.modelValue)?.label ?? this.allLabel
    },
  },
  methods: {
    choose(value) {
      this.$emit("update:modelValue", value)

      // Fathom event, e.g. "Filter Show Caves"
      const option = this.options.find((option) => option.value === value)
      trackEvent(`Filter ${this.label} ${option?.label ?? this.allLabel}`)
    },
  },
}
</script>
